import React from 'react';

// Components
import { ErrorMessage } from './ErrorMessage';

interface Props {
  label: string;
  name: string;
  value: string;
  errorMessage?: string;
  checked?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const InputRadio: React.FC<Props> = ({
  label,
  name,
  value,
  errorMessage,
  checked,
  onChange,
}) => {
  return (
    <div>
      <div>
        <input
          className="radio"
          id={`${name}-${value}`}
          type={'radio'}
          name={name}
          value={value}
          onChange={onChange}
          checked={checked}
        />
        <label htmlFor={`${name}-${value}`}>{label}</label>
      </div>
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
};
